import request from '@/utils/request'
import { envInfo } from '@/constants/envInfo'
//获取租户分页列表
export function getTenantList(params) {
  return request({
    url: envInfo.bgApp.tenantPath + '/manager/find/page',
    method: 'get',
    params
  })
}

//获取当前租户列表
export function getCurrentTenantList() {
  return request({
    url: envInfo.bgApp.tenantPath + '/manager/findCurrentTenantList',
    method: 'get',
  })
}

//设置当前租户
export function setCurrentTenant(tenantId, productKey) {
  return request({
    url: envInfo.bgApp.ssoPath + '/param/decided/tenant',
    method: 'post',
    data: {tenantId : tenantId, productKey : productKey}
  })
}

//保存租户
export function saveTenant(params) {
    return request({
      url: envInfo.bgApp.tenantPath + '/manager/create',
      method: 'post',
      data: params
    })
  }
  
  //删除租户
  export function deleteTenant(params) {
    return request({
      url: envInfo.bgApp.tenantPath + '/manager/delete/'+params.tenantId,
      method: 'delete'
    })
  }
  
  //更新租户
  export function updateTenant(params) {
    return request({
      url: envInfo.bgApp.tenantPath + '/manager/update',
      method: 'put',
      data: params
    })
  }

  //上传租户图像
  export function updateTenantAvatar(params) {
    return request({
      url: envInfo.bgApp.tenantPath + '/tenant/setting/upload/avatar',
      method: 'post',
      data: params
    })
  }

  //更新租户名
  export function updateTenantName(params) {
    return request({
      url: envInfo.bgApp.tenantPath + '/tenant/setting/update',
      method: 'put',
      data: params
    })
  }

  ///////////////==========系统管理员
  //获取租户账号
  export function _sys_getMountAccounts(params) {
    return request({
        url: envInfo.bgApp.tenantPath + '/sys/user/account/page',
        method: 'get',
        params
    })
  }

  //挂载租户
  export function _sys_mountAccount(params) {
    return request({
        url: envInfo.bgApp.tenantPath + '/sys/user/mountAccount',
        method: 'post',
        data: params
      })
  }

  //删除租户
  export function _sys_deleteTenantMount(params) {
    return request({
      url: envInfo.bgApp.tenantPath + '/sys/user/deleteMount',
      method: 'delete',
      data: params
    })
  }

   ///////////////==========租户管理员
//获取租户账号
export function _tenant_getMountAccounts(params) {
  return request({
      url: envInfo.bgApp.tenantPath + '/tenant/user/account/page',
      method: 'get',
      params
  })
}

//挂载租户
export function _tenant_mountAccount(params) {
  return request({
      url: envInfo.bgApp.tenantPath + '/tenant/user/mountAccount',
      method: 'post',
      data: params
    })
}

//删除租户
export function _tenant_deleteTenantMount(params) {
  return request({
    url: envInfo.bgApp.tenantPath + '/tenant/user/deleteMount/',
    method: 'delete',
    data: params
  })
}
  